var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReleasesListAdminTable',{attrs:{"showCreatedAt":"","showUpdatedAt":"","releases":_vm.releases},on:{"delete":_vm.deleteRelease}})}
var staticRenderFns = []

export { render, staticRenderFns }